export const newItemForm = [
    { name: "user_id", label: "Responsable", type: "select", options: [] },
    { name: "description", label: "Descripción" },
    { name: "image", label: "Imágen", type: "file" },
    { name: "limit_date", label: "Fecha límite", type: "date" },
];
